<hs-card [hsLayer]="'one'">
  <hs-card-body>
    <div class="flex flex-row gap-4 mb-3 items-center">
      @if (cardIcon()) {
        <hs-icon [width]="32" [height]="32" [innerHTML]="cardIcon()"></hs-icon>
      }

      <div hsCardTitle>{{ cardTitle() }}</div>
    </div>

    <ng-content></ng-content>
  </hs-card-body>
</hs-card>
